export default class SuperFund {
	constructor() {
		this.employerName = null;
		this.fundName = null;
		this.haveIncomeProtection = null;
	}
}
